import React, { ReactElement } from 'react'
import Image from 'next/image'

const arePropsEqual = (oldProps: { width: any; height: any }, newProps: { width: any; height: any }) => {
    return oldProps.width === newProps.width && oldProps.height === newProps.height
}

const Loader = React.memo(({ width = 50, height = 50 }: { width?: number; height?: number }): ReactElement => {
    return (
        <Image
            width={width}
            height={height}
            src="/crazy_white.svg"
            className="rotating"
            style={{ objectFit: 'cover' }}
            alt="Pulse Reflections Logo"
            priority
        />
    )
}, arePropsEqual)

Loader.displayName = 'Loader'

export default Loader
